import useEvent from '@lyearn/core/hooks/useEvent';
import { SurveyResponseInput } from '@/types/schema';

import { QuestionPlayerProps, UserSurveyQuestionPlayerResponse } from '../../questions/types';

type Props = Pick<QuestionPlayerProps, 'response' | 'onChange'>;

const useQuestionPlayerResponse = (props: Props) => {
  const { response, onChange } = props;

  const onPostChange = useEvent((post: UserSurveyQuestionPlayerResponse['post']) => {
    onChange({ ...response, post });
  });

  const onQuestionResponseChange = useEvent((questionSurveyResponse: SurveyResponseInput) => {
    onChange({ ...response, questionSurveyResponse });
  });

  return { onPostChange, onQuestionResponseChange };
};

export default useQuestionPlayerResponse;
